export const BRAND_LIST             = 'BRAND_LIST'
export const CATEGORY_LIST          = 'CATEGORY_LIST'
export const GST_LIST               = 'GST_LIST'
export const HSN_LIST               = 'HSN_LIST'
export const CREATE_DELETE_BRAND    = 'CREATE_DELETE_BRAND'
export const CREATE_DELETE_CATEGORY = 'CREATE_DELETE_CATEGORY'
export const CREATE_DELETE_HSN      = 'CREATE_DELETE_HSN'
export const BUSINESS_ITEM_LIST     = 'BUSINESS_ITEM_LIST'
export const GET_DROPDOWN_DATA      = 'GET_DROPDOWN_DATA'
export const FETCH_BRAND_HSN        = 'FETCH_BRAND_HSN'
export const APPROVE_ITEM           = 'APPROVE_ITEM'
